export type AppNavigationGroupKey =
  | 'ordenes'
  | 'gestion-comercial'
  | 'analitica'
  | 'ajustes'
  | 'ayuda';

export interface AppNavigationItem {
  key: string;
  pageKey: string;
  label: string;
  path: `/${string}`;
  title: string;
  description: string;
  icon?: string;
  count?: number;
}

export interface AppNavigationGroup {
  key: AppNavigationGroupKey;
  label: string;
  basePath: `/${string}`;
  items: AppNavigationItem[];
}

export const APP_NAVIGATION: AppNavigationGroup[] = [
  {
    key: 'ordenes',
    label: 'Órdenes',
    basePath: '/ordenes',
    items: [
      {
        key: 'nuevo-regalo',
        pageKey: 'ordenes.nuevo-regalo',
        label: 'Nuevo Regalo',
        path: '/ordenes/nuevo-regalo',
        title: 'Nuevo Regalo',
        description: 'Pantalla base para registrar nuevas órdenes asociadas a regalos.',
        icon: 'gift',
      },
      {
        key: 'nueva-agenda',
        pageKey: 'ordenes.nueva-agenda',
        label: 'Nueva Agenda',
        path: '/ordenes/nueva-agenda',
        title: 'Nueva Agenda',
        description: 'Espacio inicial para crear y organizar nuevas agendas operativas.',
        icon: 'calendar',
      },
      {
        key: 'ordenes',
        pageKey: 'ordenes.ordenes',
        label: 'Órdenes',
        path: '/ordenes/ordenes',
        title: 'Órdenes',
        description: 'Vista prevista para consultar y gestionar el listado de órdenes.',
        icon: 'inbox',
      },
      {
        key: 'clientes',
        pageKey: 'ordenes.clientes',
        label: 'Clientes',
        path: '/ordenes/clientes',
        title: 'Clientes',
        description: 'Módulo base para consultar clientes vinculados a las órdenes.',
        icon: 'user',
      },
    ],
  },
  {
    key: 'gestion-comercial',
    label: 'Gestión Comercial',
    basePath: '/gestion-comercial',
    items: [
      {
        key: 'prospectos',
        pageKey: 'gestion-comercial.prospectos',
        label: 'Prospectos',
        path: '/gestion-comercial/prospectos',
        title: 'Prospectos',
        description: 'Listado de personas interesadas que aún no son socias.',
        icon: 'users',
      },
      {
        key: 'socios',
        pageKey: 'gestion-comercial.socios',
        label: 'Socios',
        path: '/gestion-comercial/socios',
        title: 'Socios',
        description: 'Gestión de socios y renovaciones.',
        icon: 'check',
      },
      {
        key: 'ex-socios',
        pageKey: 'gestion-comercial.ex-socios',
        label: 'Ex socios',
        path: '/gestion-comercial/ex-socios',
        title: 'Ex socios',
        description: 'Recuperación de personas con plan vencido.',
        icon: 'archive',
      },
      {
        key: 'base-de-datos',
        pageKey: 'gestion-comercial.base-de-datos',
        label: 'Base de Datos',
        path: '/gestion-comercial/base-de-datos',
        title: 'Base de Datos',
        description: 'Base de datos comercial consolidada.',
        icon: 'database',
      },
      {
        key: 'distribucion',
        pageKey: 'gestion-comercial.distribucion',
        label: 'Distribución',
        path: '/gestion-comercial/distribucion',
        title: 'Distribución',
        description: 'Distribución de asignaciones por usuario.',
        icon: 'chart',
      },
    ],
  },
  {
    key: 'analitica',
    label: 'Analítica',
    basePath: '/analitica',
    items: [
      {
        key: 'rrhh',
        pageKey: 'analitica.rrhh',
        label: 'RRHH',
        path: '/analitica/rrhh',
        title: 'RRHH',
        description: 'Tablero inicial para indicadores y reportes de recursos humanos.',
        icon: 'briefcase',
      },
      {
        key: 'ficha-medica',
        pageKey: 'analitica.ficha-medica',
        label: 'Ficha Médica',
        path: '/analitica/ficha-medica',
        title: 'Ficha Médica',
        description: 'Vista analítica reservada para información y seguimiento médico.',
        icon: 'activity',
      },
      {
        key: 'ordenes',
        pageKey: 'analitica.ordenes',
        label: 'Órdenes',
        path: '/analitica/ordenes',
        title: 'Órdenes',
        description: 'Panel analítico para revisar métricas y comportamiento de órdenes.',
        icon: 'chart',
      },
      {
        key: 'facturacion',
        pageKey: 'analitica.facturacion',
        label: 'Facturación',
        path: '/analitica/facturacion',
        title: 'Facturación',
        description: 'Módulo inicial para analítica de facturación y resultados comerciales.',
        icon: 'file-text',
      },
    ],
  },
  {
    key: 'ajustes',
    label: 'Ajustes',
    basePath: '/ajustes',
    items: [
      {
        key: 'parametros',
        pageKey: 'ajustes.parametros',
        label: 'Parámetros',
        path: '/ajustes/parametros',
        title: 'Parámetros',
        description:
          'Centro de parámetros operativos y funcionales reutilizables por la aplicación.',
        icon: 'settings',
      },
      {
        key: 'gestion-roles',
        pageKey: 'ajustes.gestion-roles',
        label: 'Gestión de Roles',
        path: '/ajustes/gestion-roles',
        title: 'Gestión de Roles',
        description: 'Configuración de acceso por página usando roles de WordPress.',
        icon: 'shield',
      },
      {
        key: 'sync-socios',
        pageKey: 'ajustes.sync-socios',
        label: 'Sync de Evo',
        path: '/ajustes/sync-socios',
        title: 'Sync de Evo',
        description:
          'Pipelines de sincronización con EVO: socios (EVO → SGI y SGI → WordPress) y prospectos.',
        icon: 'refresh',
      },
      {
        key: 'avance-etapas',
        pageKey: 'ajustes.avance-etapas',
        label: 'Avance de etapas',
        path: '/ajustes/avance-etapas',
        title: 'Avance de etapas',
        description:
          'Cron de avance automático del embudo de venta: encendido, hora de ejecución, corridas y liberación de lock.',
        icon: 'refresh',
      },
      {
        key: 'logs-auditoria',
        pageKey: 'ajustes.logs-auditoria',
        label: 'Log y Auditoria',
        path: '/ajustes/log-y-auditoria',
        title: 'Log y Auditoria',
        description: 'Historial centralizado de acciones relevantes del sistema.',
        icon: 'list',
      },
    ],
  },
  {
    key: 'ayuda',
    label: 'Ayuda',
    basePath: '/ayuda',
    items: [
      {
        key: 'ayuda',
        pageKey: 'ayuda',
        label: 'Ayuda',
        path: '/ayuda',
        title: 'Ayuda',
        description: 'Guías breves por sección para usar bien cada flujo del sistema.',
        icon: 'help-circle',
      },
    ],
  },
];

export function getNavigationGroup(groupKey: AppNavigationGroupKey): AppNavigationGroup {
  const group = APP_NAVIGATION.find((item) => item.key === groupKey);

  if (!group) {
    throw new Error(`Navigation group "${groupKey}" is not defined.`);
  }

  return group;
}

export function findNavigationItemByPageKey(pageKey: string): AppNavigationItem | null {
  for (const group of APP_NAVIGATION) {
    const item = group.items.find((entry) => entry.pageKey === pageKey);

    if (item) {
      return item;
    }
  }

  return null;
}
